export function preventScrolling() {
  const scroll_view = document.getElementById('scroll-view')
  if (scroll_view) scroll_view.classList.add('modal-open')
}

export function allowScrolling() {
  const scroll_view = document.getElementById('scroll-view')
  if (scroll_view) scroll_view.classList.remove('modal-open')
}



// WEBPACK FOOTER //
// ./src/lib/scrollViewControl.js